<div class="loader-container loader-container--page">
  <div class="loader">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" />
    </svg>
  </div>
</div>
